// extracted by mini-css-extract-plugin
export default {"idCell":"HotelIdCell_idCell__DaBfR"};